// window.currClicked = {};

/**
 * For each .chips container inside .chip-filters, watch for child changes
 * and toggle the sibling .clear-filters button based on whether chips exist.
 */
document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.chip-filters').forEach(function (chipFilters) {
        const chipsEl = chipFilters.querySelector('.chips');
        const clearBtn = chipFilters.querySelector('.clear-filters');
        const body = document.querySelector('body');
        if (!chipsEl || !clearBtn) return;

        function syncVisibility() {
            chipFilters.style.display = chipsEl.children.length > 0 ? '' : 'none';
            clearBtn.style.display = chipsEl.children.length > 0 ? '' : 'none';

            if ( chipsEl.children.length > 0 ) { 
                body.classList.add('has-filter-chips');
            } else {
                body.classList.remove('has-filter-chips');
            }
        }

        syncVisibility();

        new MutationObserver(syncVisibility).observe(chipsEl, { childList: true });
    });

    // Watch for class changes on the specialty wrapper to focus the input when active
    const specialtyWrapper = document.querySelector('#specialtyWrapper');
    
    if (specialtyWrapper) {
        new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                if (mutation.attributeName === 'class') {
                    
                    const hasActive = specialtyWrapper.classList.contains('menu--active');
                    if(hasActive) {
                        document.getElementById('specialtyInput').focus();
                    }
                }
            });
        }).observe(specialtyWrapper, { attributes: true, attributeFilter: ['class'] });
    }
    const locationWrapper = document.querySelector('#locationWrapper');
    
    if (locationWrapper) {
        new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                if (mutation.attributeName === 'class') {
                    
                    const hasActive = locationWrapper.classList.contains('menu--active');
                    if(hasActive) {
                        document.getElementById('locationsInput').focus();
                        document.getElementById('locationsInput').addEventListener('change', function() {
                            if (this.value && this.value.length > 0) {
                                this.value = '';
                            }
                        });
                    }
                }
            });
        }).observe(locationWrapper, { attributes: true, attributeFilter: ['class'] });
    }
});


// Listen for changes in selected specialties and locations
// Dispatched from "aya-search.js"

document.addEventListener("aya:specialties-changed", (e) => {
  const { expertiseTexts, professionText, chipCount } = e.detail; // e.g. ["Cardiology", "ICU"]
  const expertiseTextsContainer = document.querySelector('#specialtyWrapper .search-placeholder');
  if (expertiseTextsContainer) {
    expertiseTextsContainer.innerText =
      chipCount > 0
        ? `${professionText}: ${expertiseTexts.join(', ')}`
        : 'Search specialties by profession';
  }
});

document.addEventListener("aya:locations-changed", (e) => {
  const locationTexts = e.detail.locationTexts; // e.g. ["New York", "Los Angeles"]
  const locationTextsString = locationTexts.join(', ');
  const locationTextsContainer = document.querySelector('#locationWrapper .search-placeholder');
  if (locationTextsContainer) {
    locationTextsContainer.innerText = locationTextsString;
  }

});